module.exports = __webpack_public_path__ + "img/team-08.2d416332.jpg";